<template>
  <div class="pad30" v-if="loaded">
    <h2 class="f18 fb normal gray_2">员工管理</h2>
    <div class="box20"></div>
    <div class="flex flex-wrap flex1 items-center mar20-b">
      <div>
        <el-input class="w200 mar20_r" placeholder="请输入员工姓名或手机号" v-model.trim="phoneOrName"></el-input>
      </div>
      <el-button @click="phoneOrName = ''">重置</el-button>

      <el-button type="primary" @click="getStaffList">查询</el-button>

      <el-button type="primary" class="mar-20-l" @click="openAddStaff">引入员工</el-button>
    </div>
    <el-table :data="staffList" @selection-change="staffSelect" row-key="shopStaffId" style="width: 100%">
      <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column show-overflow-tooltip prop="boName" label="员工姓名" />
      <el-table-column prop="mobilePhoneCn" label="联系电话" />
      <el-table-column v-if="cateModel && cateModel.funcSettingMap && cateModel.funcSettingMap.is_staff_sync == '1'" prop="deptName" label="所属部门" />
      <el-table-column prop="operationName" label="创建人" />
      <el-table-column prop="creationDate" label="创建时间" />
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button type="primary" @click="editStaff(scope.row)">编辑</el-button>
          <el-button type="primary" class="mar15-l" @click="deleteStaff(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex items-center mar20-t">
      <el-button type="primary" :disabled="this.multipleSelection.length == 0" @click="deleteStaffList">批量删除 </el-button>
      <div class="gray9 flex-auto mar-20-l">共 {{ pageTotal }} 条记录 第 {{ pageNum }} / {{ totalPage }} 页</div>
      <el-pagination
        layout="prev, pager, next, sizes, jumper"
        background
        hide-on-single-page
        :page-size.sync="pageSize"
        :page-count="totalPage"
        :current-page.sync="pageNum"
        :page-sizes="[6, 10, 20]"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <el-dialog title="编辑员工" :visible.sync="dialogEditVisible">
      <el-form :model="editStaffForm">
        <el-form-item label="员工手机号" :label-width="formLabelWidth" prop="mobilePhone">
          <el-input v-model="editStaffForm.mobilePhone" :disabled="true" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="员工姓名" :label-width="formLabelWidth" prop="boName">
          <el-input v-model="editStaffForm.boName" :disabled="boObj.boName ? true : false" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          v-if="cateModel && cateModel.funcSettingMap && cateModel.funcSettingMap.is_staff_sync == '1'"
          label="所属部门"
          prop="deptId"
          :label-width="formLabelWidth"
        >
          <!-- <el-select style="width: 100%" v-model="editStaffForm.deptId" filterable clearable placeholder="请选择员工所属部门">
            <el-option v-for="item in deptList" :key="item.deptId" :label="item.deptName" :value="item.deptId"></el-option>
          </el-select> -->
          <el-cascader class="w100-full" :options="deptData" v-model="editStaffForm.deptId" :props="deptProps" filterable clearable></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="(dialogEditVisible = false), (editStaffForm = {})">取 消</el-button>
        <el-button type="primary" @click="submitStaffForm" :loading="confirmLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="引入员工" :visible.sync="dialogAddVisible" width="550px">
      <el-form class="seller-style" ref="addStaffForm" :model="addStaffForm" label-width="100px" label-suffix=" : ">
        <el-alert title="" type="success" :closable="false" show-icon>
          <div slot="title">
            未注册过的员工填写姓名后会通过手机号自动注册
            <template v-if="cateModel && cateModel.funcSettingMap && cateModel.funcSettingMap.is_staff_sync == '1'">
              ，所属部门基础信息可在<span class="pointer mar10-l fb" @click="toDept">【部门设置】</span>菜单中维护
            </template>
          </div>
        </el-alert>
        <div class="box10"></div>
        <el-form-item label="员工手机号" prop="mobilePhone" :rules="addStaffFormRule.mobilePhone">
          <el-input
            v-model="addStaffForm.mobilePhone"
            type="number"
            maxlength="11"
            placeholder="请输入员工手机号"
            autocomplete="off"
            oninput="if(value.length > 11) value=value.slice(0, 11)"
            v-on:input="getUserByPhone"
          ></el-input>
        </el-form-item>
        <el-form-item label="员工姓名" prop="boName" :rules="addStaffFormRule.boName">
          <el-input v-model="addStaffForm.boName" placeholder="请输入员工姓名" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item
          v-if="cateModel && cateModel.funcSettingMap && cateModel.funcSettingMap.is_staff_sync == '1'"
          label="所属部门"
          prop="deptId"
          style="margin-bottom: 5px"
        >
          <el-cascader class="w100-full" :options="deptData" v-model="addStaffForm.deptId" :props="deptProps" filterable clearable></el-cascader>
          <!-- <el-select style="width: 100%" v-model="addStaffForm.deptId" filterable clearable placeholder="请选择员工所属部门">
            <el-option v-for="item in deptList" :key="item.deptId" :label="item.deptName" :value="item.deptId"></el-option>
          </el-select> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitStaffFormAdd" :loading="confirmLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
  <div style="min-height: 900px" v-else></div>
</template>

<script>
import { mapState } from "vuex";
import request from "@/utils/request";
import requestSC from "@/utils/requestSC";
import requestApi from "@/utils/requestApi";
import { Loading } from "element-ui";

export default {
  data() {
    return {
      loaded: false,
      env: process.env,
      groupList: [],
      staffList: [],
      deptList: [],
      deptData: [],
      multipleSelection: [],
      orgMultipleSelection: [],
      // 搜索
      groupId: "",
      phoneOrName: "",
      customerPhone: "",
      pageSize: 10,
      pageNum: 1,

      totalPage: 10,
      pageTotal: 0,

      dialogEditVisible: false,
      formLabelWidth: "120px",

      editStaffForm: {
        boName: "",
        deptId: "",
        mobilePhone: "",
      },
      groupEditVisible: false,

      dialogAddVisible: false,
      dialogAddOrgVisible: false,
      addStaffForm: {
        boName: "",
        deptId: "",
        mobilePhone: "",
      },
      confirmLoading: false,
      disabled: true,
      addStaffFormRule: {
        boName: { required: true, message: "请输入员工姓名" },
        mobilePhone: { required: true, message: "请输入员工手机号" },
      },
      cateModel: {},
      deptProps: {
        expandTrigger: "hover",
      },
      boObj: {},
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
    enterprise: (state) => state["shop/shop"].enterprise,
  }),
  watch: {
    dialogAddVisible: function (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.addStaffForm.clearValidate();
        });
      }
    },
  },
  created() {
    requestSC.get("rest/mj/goods/seq/shopConfig").then((res) => {
      this.cateModel = res.data || {};
    });
    this.getStaffList();
    this.getDeptList();
    console.log("cateModel", this.cateModel);
  },
  methods: {
    toDept() {
      if (self != top) {
        window.parent.postMessage(
          { fn: "open", data: { url: `https://baseqlw.nxin.com/BIZ/BIZMarket/MarketSettingNowUsed?appid=1710022144390000101`, title: "部门设置", target: 0 } },
          "*"
        );
      } else {
        window.open(`https://baseqlw.nxin.com/BIZ/BIZMarket/MarketSettingNowUsed?appid=1710022144390000101`);
      }
    },
    openAddStaff() {
      this.dialogAddVisible = true;
    },
    getStaffList() {
      let loadingInstance1 = Loading.service({ fullscreen: true });
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/shop/shopstaff/selListByPage`, {
          phoneOrName: this.phoneOrName,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.pageTotal = res.data.total;
          this.staffList = res.data.list;
          this.totalPage = res.data.pages;
          this.loaded = true;
          loadingInstance1.close();
        });
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getStaffList();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getStaffList();
    },
    getDeptList() {
      request
        .post(`${process.env.VUE_APP_OPEN}nxin.qlwbase.getmarket/3.0?open_req_src=nxmall_agr`, {
          EnterpriseIds: this.enterprise.default.ID,
          IsUsed: 1,
          PageIndex: 1,
          PageSize: 10000,
        })
        .then((res) => {
          this.deptList = res.data;

          const arrToTree = (arr, pid = "0") =>
            arr
              .filter((item) => item.pid == pid)
              .map((item) => ({ value: item.marketId, label: item.marketName, children: item.isEnd ? null : arrToTree(arr, item.marketId) }));
          this.deptData = arrToTree(res.data);
        });
    },
    editStaff(item) {
      this.boObj = JSON.parse(JSON.stringify(item));

      this.editStaffForm = {
        ...this.editStaffForm,
        ...item,
      };

      this.dialogEditVisible = true;
      this.$nextTick(() => {
        if (item.deptAxis) {
          this.$set(this.editStaffForm, "deptId", item.deptAxis.split("$"));
        }
      });
    },
    submitStaffForm() {
      this.confirmLoading = true;
      let deptId = "";
      let deptAxis = "";
      if (this.editStaffForm.deptId && Array.isArray(this.editStaffForm.deptId) && this.editStaffForm.deptId.length) {
        deptId = JSON.parse(JSON.stringify(this.editStaffForm.deptId)).pop();
        deptAxis = this.editStaffForm.deptId.join("$");
      }
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/shop/shopstaff/edit`, {
          shopStaffId: this.editStaffForm.shopStaffId,
          boName: this.editStaffForm.boName,
          deptId,
          deptAxis,
        })
        .then((res) => {
          if (res.code === "0") {
            this.dialogEditVisible = false;
            this.editStaffForm = {
              boName: "",
              deptId: "",
              mobilePhone: "",
            };
            this.pageNum = 1;
            this.getStaffList();
          } else {
            this.$message.error(res.msg);
          }
          this.confirmLoading = false;
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    staffSelect(val) {
      console.log("val", val);
      this.multipleSelection = val || [];
    },
    deleteStaff(item) {
      this.$confirm("您是否要删除当前所选员工:" + item.boName, "提示").then(() => {
        requestApi
          .post(`${process.env.VUE_APP_APITAAS}sctrading/shop/shopstaff/del`, {
            shopStaffId: item.shopStaffId,
          })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("删除成功");
              this.pageNum = 1;
              this.getStaffList();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },
    deleteStaffList() {
      if (this.multipleSelection.length == 0) {
        this.$message.info("请选择员工");
        return;
      }
      let shopStaffIdList = [];
      this.multipleSelection.forEach(function (item) {
        const data = item.shopStaffId;
        shopStaffIdList.push(data);
      });
      this.$confirm("您是否要删除当前所选员工", "提示").then(() => {
        requestApi
          .post(`${process.env.VUE_APP_APITAAS}sctrading/shop/shopstaff/bachDel`, {
            shopStaffIdList,
          })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("删除成功");
              this.pageNum = 1;
              this.getStaffList();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },

    getUserByPhone() {
      if (!this.addStaffForm.mobilePhone || this.addStaffForm.mobilePhone.length != 11) {
        this.addStaffForm.boName = "";
        this.$refs.addStaffForm.clearValidate("boName");
        return;
      }
      this.$store
        .dispatch("app/getUserByPhone", {
          open_req_src: "nxmall_agr_vue",
          mobile: this.addStaffForm.mobilePhone,
        })
        .then((res) => {
          if (res && res.realName) {
            console.log("res.realName", res.realName);
            console.log("res.realName", res.realName);

            this.$nextTick(() => {
              this.$set(this.addStaffForm, "boName", res.realName);
              this.disabled = true;
            });
          } else {
            this.addStaffForm.boName = "";
            this.disabled = false;
          }
        });
    },

    submitStaffFormAdd() {
      if (this.addStaffForm.mobilePhone == "") {
        this.$message.error("请输入员工手机号");
        return;
      }
      const reg = /^1\d{10}$/;
      if (this.addStaffForm.mobilePhone && (this.addStaffForm.mobilePhone.length !== 11 || !reg.test(this.addStaffForm.mobilePhone))) {
        this.$message.error("手机号格式有误");
        return;
      }
      if (this.addStaffForm.boName == "") {
        this.$message.error("请输入员工姓名");
        return;
      }
      this.confirmLoading = true;
      let deptId = "";
      let deptAxis = "";
      if (this.addStaffForm.deptId && Array.isArray(this.addStaffForm.deptId) && this.addStaffForm.deptId.length) {
        deptId = JSON.parse(JSON.stringify(this.addStaffForm.deptId)).pop();
        deptAxis = this.addStaffForm.deptId.join("$");
      }
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/shop/shopstaff/add`, {
          mobilePhone: this.addStaffForm.mobilePhone,
          boName: this.addStaffForm.boName,
          deptId,
          deptAxis,
        })
        .then((res) => {
          if (res.code == "0") {
            this.$message.success("添加成功");
            this.pageNum = 1;
            this.$nextTick(() => {
              this.$refs.addStaffForm.resetFields();
            });
            this.getStaffList();
            this.dialogAddVisible = false;
            this.dialogAddOrgVisible = false;
          } else {
            this.$message.error(res.msg);
          }
          this.confirmLoading = false;
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "list.scss";
</style>

<style>
.el-button--primary:hover,
.el-button--primary:focus {
  background: #0095f1;
  border-color: #0095f1;
  color: #ffffff;
}

.el-button--primary:active {
  background: #0095f1;
  border-color: #0095f1;
  color: #ffffff;
  outline: none;
}

.el-button--primary {
  color: #ffffff;
  background-color: #0095f1;
  border-color: #0095f1;
}

.el-button:active {
  color: #ffffff;
  outline: none;
}

.el-message-box .el-button:active {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-message-box .el-button:hover,
.el-message-box .el-button:focus {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:hover,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:active {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-select-dropdown__item.selected {
  color: #0095f1;
  font-weight: bold;
}
</style>
